Ext.define('SA.view.sidebar.data.DataFoldersBrowser', {
    alias: 'widget.data-folders-browser',
    extend: 'SA.view.SimpleContainer',

    baseCls: 'sa-data-folders-browser',
    floating: true,

    items: [
        {
            xtype: 'simple-container',
            cls: 'sa-data-folders-browser-header',

            items: [
                {
                    xtype: 'component',
                    cls: 'sa-data-folders-browser-title',
                    itemId: 'title'
                }, {
                    xtype: 'close-button',
                    closeAction: 'hide'
                }
            ]
        }, {
            xtype: 'simple-container',
            cls: 'sa-data-folders-browser-body',

            items: [
                {
                    xtype: 'load-mask',
                    backgroundColor: '#f5f5f8',
                    hidden: true,
                    itemId: 'loadMask',
                    spinnerSize: 'medium',
                    zIndex: 150
                }, {
                    xtype: 'data-folders-tree'
                }, {
                    xtype: 'simple-container',
                    cls: 'sa-data-folders-browser-results-wrap',

                    items: [
                        {
                            xtype: 'sa-text-field',
                            clearButton: true,
                            cls: 'sa-data-folders-browser-filter-field',
                            emptyText: 'Filter',
                            icon: true,
                            itemId: 'filter-text',
                            ui: 'compact'
                        }, {
                            xtype: 'data-search-no-results',
                            hidden: true,
                            text: 'No results found. Please edit or remove your filter.'
                        }, {
                            xtype: 'data-search-results',
                            enableClickableLeafPaths: false
                        }
                    ]
                }
            ]
        }, {
            xtype: 'component',
            cls: 'sa-data-folders-browser-footer'
        }
    ],

    statics: {
        lastOpenedPaths: new Map(),

        getLastOpenedPath({censusRelease, dataset, editionOption}) {
            return this.lastOpenedPaths.get(JSON.stringify({censusRelease, dataset, editionOption}));
        },

        setLastOpenedPath({censusRelease, dataset, editionOption}, path) {
            this.lastOpenedPaths.set(JSON.stringify({censusRelease, dataset, editionOption}), path);
        }
    },

    initComponent() {
        this.callParent();

        this.requestHandler = new SA.data.DataFoldersAttributesRequestHandler(this.location);

        this.updateSize();

        this.tree = this.down('data-folders-tree');
        this.noResults = this.down('data-search-no-results');
        this.results = this.down('data-search-results');
        this.filterText = this.down('#filter-text');
        this.loadMask = this.down('#loadMask');
    },

    clearResults() {
        this.unfilteredResults = [];

        this.results.clear();
    },

    getResultAttributeIds() {
        return this.results.getAttributeIds();
    },

    initEvents() {
        this.callParent();

        this.tree.on('hover:folder', this.onFolderHover, this);
        this.tree.on('select', this.onFolderSelect, this);
        this.filterText.on('change', SA.createBuffered(this.refreshResults, 250), this);
        this.results.on('select', this.onVariableSelect, this);
        this.results.on('click:path', this.onPathClick, this);

        SA.Viewport.on('resize', this.updateSize, this);
        SA.EventBus.on('metadata-window:click:path', this.onMetadataWindowPathClick, this);
    },

    onDestroy() {
        this.destroyed = true;

        this.callParent();

        SA.Viewport.un('resize', this.updateSize, this);
        SA.EventBus.un('metadata-window:click:path', this.onMetadataWindowPathClick, this);
    },

    onFolderHover(tree, folder) {
        this.requestHandler.request(folder);
    },

    onFolderSelect(tree, folder) {
        if (folder === this.selectedFolder) {
            return;
        }

        this.selectedFolder = folder;
        this.filterText.clear();

        if (!folder) {
            return;
        }

        this.self.setLastOpenedPath({censusRelease: this.params.getCensusRelease(), dataset: this.params.getDataset(), editionOption: this.params.getEditionOption()}, this.tree.getPath(folder));

        var request = this.mostRecentRequest = this.requestHandler.request(folder);

        request.then(results => {
            if (this.mostRecentRequest !== request || this.destroyed) {
                return;
            }

            this.unfilteredResults = results;

            this.refreshResults();
        });
    },

    onMetadataWindowPathClick({path}) {
        this.tree.selectCurrentOrAncestorFolderAtPath(path);
    },

    onPathClick(path) {
        this.tree.selectCurrentOrAncestorFolderAtPath(path);
    },

    onVariableSelect(list, attribute) {
        this.fireEvent('select', this, attribute);
    },

    refreshResults() {
        var getDisplayName = result => SA.view.sidebar.data.DataSearchResults.getDisplayName(result),
            isHierarchical = ({dataset_series: dataset}) => SA.data.Datasets.isHierarchical(dataset),
            isMatchingFilter = result => getDisplayName(result).toLowerCase().includes(this.filterText.getValue().trim().toLowerCase()),
            results = this.unfilteredResults.filter(result => isMatchingFilter(result) || isHierarchical(result))
                .map(result => isMatchingFilter(result) ? {result} : {placeholder: result});

        this.filterText.setDisabled(this.unfilteredResults.length === 0);
        this.noResults.setVisible(!!this.filterText.getValue() && results.length === 0);

        this.results.setResults(results);

        if (results.findIndex(({result}) => result) > 0) {
            this.results.scrollToFirstNonPlaceholderResult();
        }
        else {
            this.results.scrollToTop();
        }
    },

    setArrowTarget(target) {
        this.getPlugin('sa-arrow').setTarget(target);
    },

    setSelectedVariables(variables) {
        this.results.setSelected(variables);
    },

    updateSize() {
        var sidebarWidth = SA.Sidebar.getWidth();

        Ext.suspendLayouts();

        this.setHeight(Math.max(300, Ext.dom.Element.getViewportHeight() - 100));
        this.setWidth(Ext.Number.constrain(Ext.dom.Element.getViewportWidth() - sidebarWidth, sidebarWidth, 840));

        Ext.resumeLayouts(true);
    },

    view({title, year, params}) {
        var censusRelease = params.getCensusRelease(),
            dataset = params.getDataset(),
            editionOption = params.getEditionOption(),
            path = params.getPath() ?? this.self.getLastOpenedPath({censusRelease, dataset, editionOption});

        this.params = params;
        this.selectedFolder = null;

        this.down('#title').update(title);

        this.filterText.clear();
        this.filterText.setDisabled(true);
        this.clearResults();

        if (path) {
            this.loadMask.show();

            this.tree.viewFolderAtPath(path, dataset, year, censusRelease, this.location).then(() => {
                this.loadMask.hide();
                this.tree.scrollSelectedFolderIntoView();
            });
        }
        else {
            this.tree.viewRoot(dataset, year, censusRelease, this.location);
        }
    }
});